import { render, staticRenderFns } from "./main-preview.vue?vue&type=template&id=623f76b5"
import script from "./main-preview.vue?vue&type=script&lang=js"
export * from "./main-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports